<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'title.document_moha' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <!--    filter-->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <app-filter-contract-digitization (data)="getDataTable($event)"
                                        [featureStatus]="featureStatus"
                                        [pageSize]="paginate.pageSize"
                                        [page]="paginate.currentPage"
                                        [reload]="reloadFilter"
                                        [sort]="sorts"
                                        #searchComponent
      ></app-filter-contract-digitization>
    </mat-accordion>

    <!--    table-->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel class="mt-3" expanded="true">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <span>{{'enterprise_contract.list_digital_contract_moha' | translate}}&nbsp;
            <br>
            ({{'digital_contract.field.contract_active' | translate}}: {{contractDigitalFilter.totalContractsActive}}
            - {{'search_form.memory_storage' | translate}}
            : {{ convertCapacity(contractDigitalFilter.capacityContractsActive) }}<i
              *ngIf="contractDigitalFilter.totalContractsInactive > 0">,</i>
            <span
              *ngIf="contractDigitalFilter.totalContractsInactive > 0"> {{'digital_contract.field.contract_inactive' | translate}}
              : {{contractDigitalFilter.totalContractsInactive}}
              - {{'search_form.memory_storage' | translate}}
              : {{ convertCapacity(contractDigitalFilter.capacityContractsInactive) }}</span>)

          </span>
          <div class="pull-right list-btn" *ngIf="!isSigning; else showSigningBackground">
              <!-- Button -->
              <!-- <button class="mr-1 list-btn-1" mat-stroked-button color="primary" (click)="openSignSlot()" [disabled]="dataSelected.length == 0" appTrackEvent="w.btn.hd_ky_duyet.ky_theo_lo">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_lot' | translate}}
              </button> -->
              <!-- Button -->
              <!-- <button class="mr-1 button-sign-all" 
              (click)="openSignAll()" mat-stroked-button color="primary" appTrackEvent="w.btn.hd_ky_duyet.ky_tat_ca_hd">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_all' | translate}}
              </button> -->
            <button  *ngIf="featureStatus && !statusBackup" class="mr-1" color="primary" mat-stroked-button
                    (click)="onClickBtnCreate()"
                    type="button" appTrackEvent="w.btn.hdsohoatoiquanly.them"
            >
              <!--                  *ngIf="mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM"-->
              <mat-icon class="mr-0">add_circle</mat-icon>
              {{'button.add' | translate}}
            </button>
            <button  *ngIf="featureStatus && !statusBackup" class="mr-1" color="primary" mat-stroked-button
                    (click)="onAddLot()"
                    type="button" appTrackEvent="w.btn.hdsohoatoiquanly.them_moi_lo"
            >
              <!--                  *ngIf="mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM"-->
              <mat-icon class="mr-0">note_add</mat-icon>
              {{'button.add_lot' | translate}}
            </button>
            <!-- <button mat-stroked-button color="primary" type="button" class="" appTrackEvent="w.btn.hdsohoatoiquanly.tai_hop_dong"
                    [disabled]="dataSelected.length === 0" (click)="multiDownload()">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'button.downloadContract' | translate}}
            </button> -->
          </div>
          <ng-template #showSigningBackground>
              <div layout-align="center center end-start">
                <div class="row">
                  <div class="col-11">
                    <span>{{'messages.signing_progress' | translate}} {{processedPercent}}%</span>
                    <mat-progress-bar mode="determinate" [value]="processedPercent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                  <div class="col-1" layout="row" layout-align="end center">
                    <button mat-icon-button color="primary" (click)="handleSingingProcess()" matTooltip="">
                      <mat-icon>gesture</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
        </mat-panel-title>
        <div *ngIf="featureStatus" class="mat-table-container">
          <mat-table (matSortChange)="onChangeSort($event)" [dataSource]="dataSource" class="mat-table-col-extra-sm" style="width: 100%; min-width: max-content;"
                     matSort>
            <!-- select -->
            <!-- <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox
                  (change)="checkAllDocument()"
                  [(ngModel)]="checkAll"
                  color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox
                  color="primary"
                  [(ngModel)]="element.checked"
                  (click)="$event.stopPropagation()"
                  (change)="onSelectionChange()"
                >
                </mat-checkbox>
              </mat-cell>
            </ng-container> -->

            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()"
                        *matCellDef="let element; let index = index"
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{pageIndex.currentPage * pageIndex.pageSize + index + 1}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- UUID Hợp đồng -->
            <ng-container matColumnDef="uuidContractMoha">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.uuid_contract' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.idMoha }}"
                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                <span class="fix-width">{{ element.idMoha }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Hợp đồng Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               mat-sort-header="name"
                               style="width: 25%;">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 25%;">
                <span (click)="$event.stopPropagation()" [matTooltip]="element.status === 7 ?
                      ('form.digital_contract.error_inactive' | translate) : element.code + ' - ' + element.name"
                      [ngStyle]="{'color': element.status === 7 ? '#8F8F8F' : '#000'}"
                      class="fix-width"
                      style="margin-left: -5px; position: relative;">
                  <i *ngIf="element.status === 7"
                     aria-hidden="true"
                     class="fa fa-exclamation-triangle ml-2 warning-active" style="font-size: 18px; color: #FF2D2D"></i>
                  <!-- <div class="tooltipActive">
                    Hợp đồng bị khóa do đơn vị không đủ dung lượng lưu trữ khi lập. Vui lòng mua thêm hoặc giải phóng bớt dung lượng sau đó bấm
                    <mat-icon>arrow_upward
                    </mat-icon> để mở khóa hợp đồng
                  </div> -->
                  {{element.code + ' - ' + element.name}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 25%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Người lao động Column -->
            <ng-container matColumnDef="personalEmployment">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               mat-sort-header="name"
                               style="width: 25%;">
                {{'headertable.worker_contract' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 25%;">
                <span>
                  {{element.personalEmployment}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 25%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Hợp đồng cha Column -->
            <ng-container matColumnDef="parent">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 20%;">
                {{'form.doc_reference' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allParentCode }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allParentCode }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Loai hop dong Column -->
            <ng-container matColumnDef="serviceTypeName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'search_form.type_of_doc' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom" matTooltip="{{ element.contractType }}"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.contractType }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Column dung luong -->
            <ng-container matColumnDef="memoryStorage">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'search_form.memory_storage' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom"
                        matTooltip="{{ element.capacity / 1024 / 1024 | number:'.0-3' }}MB"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.capacity / 1024 / 1024 | number:'.0-3'}}MB</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Ngày hiệu lực column -->
            <ng-container matColumnDef="effectiveDate">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               mat-sort-header
                               style="max-width: 10%;">
                <span>
                  {{'headertable.document_date' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom number-cell-center"
                        matTooltip="{{element.effectiveDate}}"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.effectiveDate }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Ngày hết hiệu lực Column -->
            <ng-container matColumnDef="expiredDate">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom"
                               mat-sort-header
                               style="max-width: 10%;">
                {{'headertable.document_exprise_date' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()"
                        *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;">
                <span>{{element.expireDate}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- Người tạo -->
            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'cloud_ca_management.add_new.create_by' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()"
                        *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;">
                <span>{{element.createdBy}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trang thái -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'search_form.status' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()"
                        *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;">
                <span *ngIf="element.status == 1">{{'search_form.draft' | translate}}</span>
                <span *ngIf="element.status == 2">{{'search_form.processing' | translate}}</span>
                <span *ngIf="element.status == 3">{{'search_form.denied_sign' | translate}}</span>
                <span *ngIf="element.status == 5">{{'search_form.cancelled' | translate}}</span>
                <span *ngIf="element.status == 8">{{'contract_share_partner.issued' | translate}}</span>
                <!-- <span *ngIf="element.status == 7">{{'search_form.cancelled' | translate}}</span>
                <span *ngIf="element.status == 8">{{'contract_share_partner.issued' | translate}}</span> -->
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!--            <ng-container matColumnDef="createdBy">-->
            <!--              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"-->
            <!--                               style="max-width: 10%;">-->
            <!--                {{'cloud_ca_management.add_new.create_by' | translate}}-->
            <!--              </mat-header-cell>-->
            <!--              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"-->
            <!--                        class="mat-cell-non-boder-right-bottom number-cell-center" matTooltip="{{ element.createdBy }}"-->
            <!--                        style="max-width: 10%;">-->
            <!--                <span>{{ element.createdBy }}</span>-->
            <!--              </mat-cell>-->
            <!--            </ng-container>-->

            <!-- Trạng thái chứng thực  -->
            <ng-container matColumnDef="mohaConfirmStatus">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.status_sign' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                (click)="$event.stopPropagation()">
                <nz-tag *ngIf="+element.mohaConfirmStatus === 1"
                  style="margin-right: 0px;">
                  {{'contract_terminate.no_sign' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.signing' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 4"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.signing' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">
                  {{'contract_terminate.failed' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 5"
                  [nzColor]="'red'" style="margin-right: 0px;">
                  {{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 6"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.signed' | translate}}
                </nz-tag>
                
                <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                  *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                  </nz-badge>
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                  </nz-badge>
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                  </nz-badge>
                </div> -->
                <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
                <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
                <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái xác thực NLĐ -->
            <ng-container matColumnDef="isVerifyPersonal">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.status_verify_NLD' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.isVerifyPersonal == false"
                  style="margin-right: 0px;">
                  {{'contract_terminate.not_confirm' | translate}}</nz-tag>
                <nz-tag *ngIf="element.isVerifyPersonal == true"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.confirm' | translate}}
                </nz-tag>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái gửi Nền tảng HĐLĐ -->
            <ng-container matColumnDef="mohaStatus">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.status_send' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                (click)="$event.stopPropagation()">
                <nz-tag *ngIf="+element.mohaStatus === 1"
                  style="margin-right: 0px;">
                  {{'contract_terminate.no_send' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaStatus === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.sending' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaStatus === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.failed' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.mohaStatus === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.sent' | translate}}
                </nz-tag>
                <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                  *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                  </nz-badge>
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                  </nz-badge>
                  <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                  </nz-badge>
                </div> -->
                <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
                <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
                <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                <!--                  <div style="font-size: 16px;"-->
                <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                <!--                       class="d-flex align-items-center" nz-tooltip-->
                <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                </ng-container>-->
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Lý do -->
            <ng-container matColumnDef="contractMohaErrorDescription">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom"
              >
              {{'header.reason' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" matTooltip="{{ element.contractMohaErrorDescription }}"
                        *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="max-width: 30%;"
              >
                <span class="fix-width">{{element.contractMohaErrorDescription}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- tác động -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 180px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="number-cell-center" style="min-width: 180px;">
                
                <!-- Xem chi tiết -->
                <button (click)="actionInContract('view', element.id)"
                        [disabled]="element.status === 7"
                        mat-icon-button
                >
                  <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                    visibility
                  </mat-icon>
                </button>


                <!-- Bắt đầu luồng -->
                <button mat-icon-button (click)="startSignFlow(element)" *ngIf="checkPermissionCreateContract()"
                  [disabled]="element.status !== enumContractStatus.DRAFT"
                  appTrackEvent="w.btn.hdtoilap.thuc_hien_luong_ky">
                <mat-icon *ngIf="element.status == enumContractStatus.DRAFT"
                  matTooltip="{{'enterprise_contract.buttons.start_flow' | translate}}">play_circle_outline
                </mat-icon>
                <mat-icon *ngIf="element.status !== enumContractStatus.DRAFT">play_circle_outline
                </mat-icon>
              </button>

                <!-- Update tài liệu -->
                <button (click)="actionInContract('update', element.id)"
                        [disabled]="element.status === 7 || statusBackup || element.status !== 1 "
                        mat-icon-button
                >
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.edit' | translate}}">
                    edit
                  </mat-icon>
                </button>

                <button (click)="reAuthenticate(element.id)" mat-icon-button type="button"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.chungthuclai" [disabled]="element.mohaConfirmStatus !== 3">
                    <i class="fa fa-refresh mr-1 p-1"
                      aria-hidden="true"
                      matTooltip="{{'enterprise_customer_management.buttons.sign_again' | translate}}"></i>
                  </button>


                <!-- Tải xuống -->
                <button (click)="downloadContract(element)" [disabled]="element.status === 7" mat-icon-button
                        type="button">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>

                <!-- Xóa -->
                <button [disabled]="element.status === 7 || statusBackup || element.status !== 1"
                        (click)="deleteContract(element)" mat-icon-button>
                  <i aria-hidden="true" class="fa fa-trash"
                     [ngClass]="{'disable': element.status === 7 || statusBackup || element.status !== 1}"
                     matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button>

                <!-- kích hoạt hợp đồng -->
                <button (click)="activeContract(element)"
                        *ngIf="element.status === 7"
                        mat-icon-button type="button"
                        [disabled]="statusBackup"
                >
                  <!-- <mat-icon matTooltip="{{'enterprise_contract.buttons.active' | translate}}">save_alt
                  </mat-icon> -->
                  <!-- <i  class="material-icons" aria-hidden="true">arrow_circle_up</i> -->
                  <span class="material-icons" matTooltip="{{'enterprise_contract.buttons.active' | translate}}">
                    arrow_upward
                  </span>
                </button>

              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="min-width: 180px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang rong; moi cot co mat-footer-cell rieng theo dung cot; an/hien qua class theo searchComponent.isTableLoading -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" [cdkDetailRow]="row" class="element-row" matRipple
            >
            </mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!searchComponent.isTableLoading"></mat-footer-row>
          </mat-table>
        </div>
        <div *ngIf="!featureStatus" class="mt-5" style="color: #8F8F8F; margin-bottom: 100px;">
          <div class="d-flex justify-content-center">
            {{ "digital_contract.error.digital_contract_out_date" | translate}}
          </div>
          <div class="d-flex justify-content-center">
            {{ "digital_contract.error.extend_digital" | translate}}
          </div>
        </div>

        <!-- Pagination -->
        <app-pagination (pageChange)="onChangePage($event)" *ngIf="featureStatus" [(paginate)]="paginate">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
